<div class="alert-error">
  <div *ngIf="shouldShowErrors()">
    <ng-container *ngFor="let error of listOfErrors(); first as isFirst">
      <ng-container *ngIf="isFirst">
        <!-- <span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7 0C10.8587 0 14 3.13906 14 6.99854C14 10.861 10.8587 14 7 14C3.14125 14 0 10.8609 0 6.99854C0 3.13899 3.14125 0 7 0ZM7 11.6662C7.4842 11.6662 7.875 11.2753 7.875 10.791C7.875 10.3097 7.4842 9.91582 7 9.91582C6.51879 9.91582 6.125 10.3097 6.125 10.791C6.125 11.2753 6.51879 11.6662 7 11.6662ZM6.41667 9.06984C6.43119 9.2187 6.55666 9.33237 6.70833 9.33237H7.29167C7.44334 9.33237 7.56881 9.21855 7.58333 9.06984L8.16667 2.94357C8.16667 2.27267 7.64458 1.74745 7 1.74745C6.35542 1.74745 5.83333 2.27248 5.83333 2.91436L6.41667 9.06984Z"
              fill="#DE091E" />
          </svg></span> -->
        <!-- <span class="errorMsg">  Error:  </span> -->
        <span class="col-red">
          {{getTypeOf(error) === 'function'? error():error}}
        </span>
      </ng-container>
    </ng-container>
  </div>
</div>